<div *ngIf="isLoadingCompleted">
    <app-profile-view [user_item]="user_info" [isUsersOwnProfile]="isUsersOwnProfile" [authenticatedUser]="authenticatedUser"></app-profile-view>
</div>
